import { Region } from 'utils/environment/types';

import { IUserFormData } from './types';
import {
  validateDateOfBirth,
  validateEmail,
  validateName,
  validatePhoneNumber,
  validateZipCode,
} from './utils';

interface IGetFormErrorsParams {
  region: Region;
  simplePhoneValidation?: boolean;
}
export const getFormErrors = ({ region, simplePhoneValidation }: IGetFormErrorsParams) => async (
  formData: IUserFormData
) => {
  const emailErrors = validateEmail({ formData });

  const nameErrors = validateName({ formData });

  const phoneNumberErrors = await validatePhoneNumber({
    formData,
    region,
    simpleValidation: simplePhoneValidation,
  });

  const dateOfBirthErrors = validateDateOfBirth({ formData, region });

  const zipCodeErrors = validateZipCode({ formData, region });

  return {
    ...emailErrors,
    ...nameErrors,
    ...phoneNumberErrors,
    ...dateOfBirthErrors,
    ...zipCodeErrors,
  };
};
